const storage = {
  data: {
    ITEMS_EXCLUDED_BY_PREFILTER: {},

    ITEMS: {}, // PREFILTERED
    ITEMS_MERGED: {},
    GROUPS_MERGED: {},
    REPORT_RESULTS: {},
    REPORT_RESULTS_SORTED: {},

    METRICS: {},

    LINEITEMS: [],
    ORDERS: [],
  },

  get(dataType) {
    return this.data[dataType]
  },
  getEndpoint(dataType, endpointKey) {
    const data = this.get(dataType)
    return !!data && data[endpointKey]
  },
  getAssociationAndSubId(dataType, endpointKey, associationId, subId) {
    const data = this.getEndpoint(dataType, endpointKey)
    const isValidPath = !!(data && data[associationId] && data[associationId][subId])
    return isValidPath && data[associationId][subId]
  },
  getPath(dataType, endpointKey, associationId, subId, reportPath) {
    const data = this.getEndpoint(dataType, endpointKey)
    const isValidPath = !!(data && data[associationId] && data[associationId][subId])
    return isValidPath && data[associationId][subId][reportPath]
  },
  getAll(dataType, endpointKey) {
    const data = this.getAssociationAndSubId(dataType, endpointKey, 'all-associations', 'all-secondary')
    return !!data && data['all-data']
  },

  setItemsOnPath(dataType, endpointKey, items, reportPath, associationId, subId) {
    if (!this.data[dataType][endpointKey]) {
      if (reportPath) {
        this.data[dataType][endpointKey] = { [associationId]: { [subId]: { [reportPath]: Object.freeze(items) } } }
      } else {
        this.data[dataType][endpointKey] = { [associationId]: { [subId]: Object.freeze(items) } }
      }
    } else if (!this.data[dataType][endpointKey][associationId]) {
      if (reportPath) {
        this.data[dataType][endpointKey][associationId] = { [subId]: { [reportPath]: Object.freeze(items) } }
      } else {
        this.data[dataType][endpointKey][associationId] = { [subId]: Object.freeze(items) }
      }
    } else if (reportPath) {
      if (this.data[dataType][endpointKey][associationId][subId]) {
        this.data[dataType][endpointKey][associationId][subId][reportPath] = Object.freeze(items)
      } else {
        this.data[dataType][endpointKey][associationId][subId] = { [reportPath]: Object.freeze(items) }
      }
    } else {
      this.data[dataType][endpointKey][associationId][subId] = Object.freeze(items)
    }
  },
  set(dataType, { endpointKey, items, query }) {
    const { associationId = 'all-associations', reportPath, subId = 'all-secondary' } = query
    return this.setItemsOnPath(dataType, endpointKey, items, reportPath, associationId, subId)
  },

  getStoredState(storageKey) {
    return window.localStorage.getItem(storageKey)
  },
  getStoredJson(storageKey) {
    const storedState = this.getStoredState(storageKey)

    if (!storedState) return null

    try {
      return JSON.parse(storedState)
    } catch {
      return storedState
    }
  },
  validateStoredDrawerState(storedState) {
    return ['false', 'true'].indexOf(storedState) !== -1
  },
  getDrawerState(storageKey) {
    const storedState = this.getStoredState(storageKey)
    const validStoredState = this.validateStoredDrawerState(storedState)

    return validStoredState ? storedState : 'true'
  },
  isTrue(value) {
    return value === 'true'
  },
  getTheme(storageKey) {
    return this.getStoredState(storageKey)
  },

  getDrawerWidth(storageKey) {
    const storedState = this.getStoredState(storageKey)
    return storedState && Number.parseInt(storedState, 10)
  },
}

export default storage
